import { Box, Image } from '@chakra-ui/react';
import type { HeroConfig } from '@src/components/sco/LayoutBlocks/Hero/types';
export const proTrialLandingHeroConfig: HeroConfig = {
  customHeaderInsert: <Box marginX={'auto'} paddingY={0}>
      <Image alt={'Startups Pro Logo'} height={'auto'} src={require('@public/assets/graphics/startupspro-logo.svg').default.src} width={150} />
    </Box>,
  title: <>
      Tell us what you&apos;re trying to do.
      <br />
      <Box as={'span'} color={'mochaLight'} fontWeight={'800'} letterSpacing={'tight'}>
        We&apos;ll tell you exactly how to get it done.
      </Box>
    </>,
  description: "Funding. Customers. Co-founders. Advisors. Product. Talent. One platform, built by founders who've done it — for founders who are doing it now.",
  backgroundColor: 'Maroon20',
  backgroundGradient: 'linear(to-t, BurntOrange50, transparent 75%)',
  callToAction: {
    text: 'Try Startups Pro — Free for 7 Days',
    href: '/accelerator/payment?productId=scom-accelerator-tools&couponCode=PW-TRY7-PRO',
    disclaimerText: 'No equity. No application. No contracts. Cancel anytime.'
  }
};